import { FormControl, MenuItem, Select } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import './style.scss';
import { selectSelectedRole, setSelectedRole } from '../../../redux/slices/statistics/statisticsSlice';

const RoleSelect = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const currentRole = useSelector(selectSelectedRole);

  useEffect(() => {
    dispatch(setSelectedRole('Teacher'));
  }, []);

  const handleChange = event => {
    dispatch(setSelectedRole(event.target.value));
  };

  return (
    <FormControl variant="outlined" className="role-select">
      <Select value={currentRole} onChange={handleChange}>
        <MenuItem value={'Teacher'}>{t('Teacher')}</MenuItem>
        <MenuItem value={'Student'}>{t('Student')}</MenuItem>
      </Select>
    </FormControl>
  );
};

export default RoleSelect;
